import Snowplow from '@src/snowplow'
import { navigateToMethodsPage } from '@src/verification/children/router/helpers'

export const handleMethodsClick = (props) => {
  Snowplow.trackButtonClickEvent(
    {
      action: 'return',
      destination: 'methods'
    },
    [
      Snowplow.getButtonContext({
        text: 'Use another method',
        style: 'standard'
      })
    ]
  )

  props.data.handleAlternativeMethodSelectedChange()

  return navigateToMethodsPage(props)
}
